import italianFlag from "./italy-small.png";
import spanishFlag from "./spain-small.png";
import romanianFlag from "./romania-small.png";
import ukFlag from "./uk-small.png";
import franceFlag from "./france-small.png";
import germanyFlag from "./germany-small.png";

import { Langs } from "../../translations/translate";

export default {
  [Langs.It]: italianFlag,
  [Langs.Es]: spanishFlag,
  [Langs.Ro]: romanianFlag,
  [Langs.Uk]: ukFlag,
  [Langs.Fr]: franceFlag,
  [Langs.De]: germanyFlag,
};
